import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconLatest = (props) => {
  const classes = classNames({
    icon: true,
    'icon-latest': true,
    [props.elementClass]: props.elementClass,
  });

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="65"
      height="24"
      viewBox="0 0 65 24"
      aria-label="Latest"
    >
      <rect width="65" height="24" rx="3" fill="#D93717" />
      <path
        d="M9.58129 17V7.004H11.6953V15.25H15.7553V17H9.58129ZM23.6153 17L22.8873 14.62H19.2473L18.5193 17H16.2373L19.7653 6.962H22.3553L25.8973 17H23.6153ZM21.6553 10.518C21.6086 10.3593 21.548 10.1587 21.4733 9.916C21.3986 9.67333 21.324 9.426 21.2493 9.174C21.1746 8.922 21.114 8.70267 21.0673 8.516C21.0206 8.70267 20.9553 8.936 20.8713 9.216C20.7966 9.48667 20.722 9.748 20.6473 10C20.582 10.2427 20.5306 10.4153 20.4933 10.518L19.7793 12.842H22.3833L21.6553 10.518ZM30.0289 17H27.9149V8.768H25.1989V7.004H32.7449V8.768H30.0289V17ZM40.0404 17H34.2864V7.004H40.0404V8.74H36.4004V10.938H39.7884V12.674H36.4004V15.25H40.0404V17ZM48.0144 14.228C48.0144 14.816 47.8697 15.3293 47.5804 15.768C47.291 16.2067 46.871 16.5473 46.3204 16.79C45.779 17.0233 45.1164 17.14 44.3324 17.14C43.987 17.14 43.6464 17.1167 43.3104 17.07C42.9837 17.0233 42.6664 16.958 42.3584 16.874C42.0597 16.7807 41.775 16.6687 41.5044 16.538V14.564C41.9804 14.7693 42.4704 14.9607 42.9744 15.138C43.4877 15.306 43.9964 15.39 44.5004 15.39C44.8457 15.39 45.121 15.3433 45.3264 15.25C45.541 15.1567 45.695 15.0307 45.7884 14.872C45.891 14.7133 45.9424 14.5313 45.9424 14.326C45.9424 14.074 45.8537 13.8593 45.6764 13.682C45.5084 13.5047 45.2797 13.3413 44.9904 13.192C44.701 13.0333 44.3697 12.8653 43.9964 12.688C43.763 12.576 43.511 12.4453 43.2404 12.296C42.9697 12.1373 42.7084 11.946 42.4564 11.722C42.2137 11.4887 42.013 11.2087 41.8544 10.882C41.6957 10.5553 41.6164 10.1633 41.6164 9.706C41.6164 9.10867 41.7517 8.6 42.0224 8.18C42.3024 7.75067 42.6944 7.424 43.1984 7.2C43.7117 6.976 44.3137 6.864 45.0044 6.864C45.527 6.864 46.0217 6.92467 46.4884 7.046C46.9644 7.16733 47.459 7.34 47.9724 7.564L47.2864 9.216C46.829 9.02933 46.4184 8.88467 46.0544 8.782C45.6904 8.67933 45.317 8.628 44.9344 8.628C44.673 8.628 44.449 8.67 44.2624 8.754C44.0757 8.838 43.931 8.95467 43.8284 9.104C43.735 9.25333 43.6884 9.43067 43.6884 9.636C43.6884 9.86933 43.7584 10.07 43.8984 10.238C44.0384 10.3967 44.2484 10.5507 44.5284 10.7C44.8084 10.8493 45.1584 11.0267 45.5784 11.232C46.0917 11.4747 46.5257 11.7267 46.8804 11.988C47.2444 12.2493 47.5244 12.5573 47.7204 12.912C47.9164 13.2667 48.0144 13.7053 48.0144 14.228ZM53.6813 17H51.5673V8.768H48.8513V7.004H56.3973V8.768H53.6813V17Z"
        fill="white"
      />
    </svg>
  );
};

IconLatest.propTypes = {
  elementClass: PropTypes.string,
};

export default IconLatest;
